import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { AdminFinancialMetrics } from "../../Objects/AdminDashboard/AdminFinancialMetrics"
import { GetRequest } from "../../services/ApiClientService"

/**
 * Hook responsável por buscar as métricas financeiras do painel administrativo global.
 */
export const useGetAdminFinancialMetrics = () => {
  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  /**
   * Busca os indicadores financeiros e devolve o payload no callback informado.
   * @param onSuccess Callback executado quando os dados são carregados com sucesso.
   */
  const handleGetAdminFinancialMetrics = async (onSuccess: (data: AdminFinancialMetrics) => void) => {
    enableLoad()

    try {
      const response = await GetRequest<AdminFinancialMetrics>(
        API_ROUTES.ADMIN_DASHBOARD.GET_FINANCIAL_METRICS,
        ERequestType.Admin,
      )

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess(new AdminFinancialMetrics(response.data ?? {}))
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : "Erro ao carregar métricas financeiras administrativas."
      setError("Métricas financeiras", message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetAdminFinancialMetrics,
  }
}
